/**
 * @module lib/audience/event-register
 */
import isEqual from "lodash/isEqual";
import logger from "utils/logger";

const debugTag = "[EVENT-REGISTER]";
const events = {
  "adEvent": {
    "video": ["type", "feature", "contentId", "action", "milestone", "elapsed", "duration", "autoplay"]
  },
  "ageGateEvent": ["action"],
  "clickEvent": {
    "link": ["feature", "type", "label", "position", "hierarchy", "linkType", "page"],
    "socialshare": ["feature", "type", "label", "position", "hierarchy", "linkType"],
    "button": ["feature", "type", "action", "label", "linkType"]
  },
  "engagementEvent": {
    "comment": ["feature", "type", "contentId", "action"],
    "video": ["feature", "type", "contentId", "action", "milestone", "elapsed", "duration", "autoplay"],
    "gallery": ["feature", "type", "position", "totalImages", "viewMode", "contentId", "milestone"]
  },
  "errorEvent": {
    "api": ["component", "description", "affected_event"]
  },
  "error": {
    "info": ["info", "origin", "message"]
  },
  "message": ["origin", "feature", "label"],
  "wallEvent": ["name", "type", "adsVisible", "countVisibleParagraphs", "meterCount", "meterLimit"],
  "searchEvent": ["type", "mode", "page", "query", "isLiveSuggest", "isDidYouMean", "grouping", "total", "shown", "securities", "shownSecurities"],
  "newsletterEvent": {
    "simple": ["action", "name", "type", "frequency"],
    "modal": ["action", "name", "type", "frequency"]
  },
  "page": {
    "sec": ["name", "type", "url", "contentType"]
  },
  "media_interaction": ["type", "action", "feature", "timeElapsed", "totalTime", "playbackRate", "voiceOption", "language", "viewMode", "isAutoplay"]
};

/**
 * Verify the event is a known type and it's property names are valid.
 * @param {Object} data - collection of properties
 * @param {String} eventType - to lookup
 * @param {String} [eventSubType=null]
 * @returns {Boolean}
 */
export function verifyEvent(data, eventType, eventSubType = null) {
  logger.groupCollapsed(`${debugTag}`);
  logger.info(`${debugTag} verifyEvent() | data:`, data);
  logger.info(`${debugTag} verifyEvent() | eventType:`, eventType);
  logger.info(`${debugTag} verifyEvent() | eventSubType:`, eventSubType);

  const event = !eventSubType ? events[eventType] : events[eventType][eventSubType];

  if (!event) {
    logger.error(`${debugTag} GTM Error: unknown event ${eventType}`);
    logger.groupEnd(`${debugTag}`);
    return false;
  }
  if (!isEqual(data, event)) {
    logger.warn(`${debugTag} GTM Warning: eventType=${eventType} eventSubType=${eventSubType ? eventSubType : null} should contain the following keys: ${event}`);
    logger.groupEnd(`${debugTag}`);
    return false;
  }

  logger.groupEnd(`${debugTag}`);
  return true;
}
